import script from "./WeatherWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeatherWidget.vue?vue&type=script&setup=true&lang=ts"

import "./WeatherWidget.vue?vue&type=style&index=0&id=43085bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43085bf0"]])

export default __exports__